import * as tslib_1 from "tslib";
import React from 'react';
import s from './FlagSwitcher.scss';
import Input from '../../../Input';
var FlagSwitcher = /** @class */ (function (_super) {
    tslib_1.__extends(FlagSwitcher, _super);
    function FlagSwitcher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isVisible: false,
        };
        _this.onAddNew = function () {
            var _a;
            var setFlags = _this.props.setFlags;
            var val = _this.inputNode && _this.inputNode.value;
            if (!val) {
                return;
            }
            setFlags((_a = {}, _a[val] = true, _a));
        };
        _this.onRemove = function (key) {
            var _a;
            var setFlags = _this.props.setFlags;
            setFlags((_a = {}, _a[key] = false, _a));
        };
        _this.onKeyDown = function (event) {
            if (event.repeat) {
                return;
            }
            if (event.altKey && event.ctrlKey && event.key === 'F2') {
                _this.setState({ isVisible: true });
            }
        };
        _this.onHide = function () {
            _this.setState({ isVisible: false });
        };
        return _this;
    }
    FlagSwitcher.prototype.componentDidMount = function () {
        window.addEventListener('keydown', this.onKeyDown);
    };
    FlagSwitcher.prototype.componentWillUnmount = function () {
        window.removeEventListener('keydown', this.onKeyDown);
    };
    FlagSwitcher.prototype.render = function () {
        var _this = this;
        var isVisible = this.state.isVisible;
        if (!isVisible) {
            return null;
        }
        var flags = this.props.flags;
        return (React.createElement("div", { className: s['root'] },
            React.createElement("div", { className: s['hide'], onClick: this.onHide }, "x"),
            React.createElement("div", { className: s['header'] }, "Flags"),
            React.createElement("ul", { className: s['list'] },
                flags.map(function (flag) { return (React.createElement("li", { className: s['list-item'], key: flag },
                    React.createElement("span", null, flag),
                    React.createElement("button", { className: s['remove'], onClick: function () { return _this.onRemove(flag); } }, "x"))); }),
                React.createElement("li", { className: s['list-item'] },
                    React.createElement(Input, { autoFocus: true, onEnter: this.onAddNew, className: s['input'], refInput: function (node) {
                            _this.inputNode = node;
                        } }),
                    React.createElement("button", { className: s['add'], onClick: this.onAddNew }, "Add new")))));
    };
    return FlagSwitcher;
}(React.Component));
export { FlagSwitcher };
export default FlagSwitcher;
//# sourceMappingURL=FlagSwitcher.js.map